/* eslint-disable no-process-env */
import {isoWindow} from '~/utils/window';

export const CORE_AUTH_DOMAIN =
  process.env.CORE_AUTH_DOMAIN || isoWindow.location.origin;

export const PAY_AUTH_DOMAIN = process.env.PAY_AUTH_DOMAIN;

export const PAY_AUTH_DOMAIN_ALT = process.env.PAY_AUTH_ALT_DOMAIN;
